












import Vue from 'vue';
import Nav from './components/Nav.vue';
import Footer from './components/Footer.vue';
import Notice from './components/Notice.vue';

export default Vue.extend({
  name: 'App',

  components: {

    Nav,
    Footer,
      Notice
  },

  data: () => ({
    //
  }),
});
